<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="$apollo.loading"
    :items-per-page-options="[10, 25, 50, 100]"
    fixed-header
    :items-per-page="-1"
    :search="search"
    v-model="selected"
    multi-sort
    show-select
    :height="gridHeight"
  >
    <template v-slot:item.date="{ item }"
      >{{ item.dayOfWeekLabel }}, {{ item.date | formatDate }}</template
    >
    <template v-slot:item.releaseDate="{ item }">{{
      item.releaseDate | formatDate
    }}</template>
    <template v-slot:item.closed="{ item }">
      <v-simple-checkbox v-model="item.closed" disabled></v-simple-checkbox>
    </template>
    <template v-slot:item.actions="{ item }">
      <default-list-actions
        :item="item"
        :hide-view="true"
        hide-edit
        @deleteItem="deleteItem($event)"
        @editItem="editItem($event)"
      ></default-list-actions>
    </template>
    <template v-slot:footer>
      <simple-list-actions
        v-if="selected.length > 0"
        @delete="onDelete"
        :hide-delete="$store.getters.hasAccessTo('suppliers:view_only')"
      ></simple-list-actions>
    </template>
  </v-data-table>
</template>

<script>
import DefaultListActions from "../../shared/DefaultListActions";
import SimpleListActions from "../../shared/list-actions/SimpleListActions";
export default {
  name: "closeouts-table",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    hideFooter: {
      type: Boolean,
      defaultd: () => false,
    },
  },
  components: { DefaultListActions, SimpleListActions },

  data() {
    return {
      selected: [],
      fixedHeader: true,
      windowHeight: window.innerHeight,
    };
  },

  computed: {
    gridHeight() {
      if (!this.fixedHeader) {
        return null;
      }
      return this.items && this.items.length >= 20
        ? this.windowHeight - 500
        : null;
    },
  },

  methods: {
    deleteItem(payload) {
      this.$emit("delete", payload);
    },
    editItem(payload) {
      this.$emit("edit", payload);
    },
    onDelete() {
      this.$emit("deleteRecords", [...this.selected]);
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
    });
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/closeouts/CloseoutsTable.vue